import { render, staticRenderFns } from "./embedded.vue?vue&type=template&id=8cf3aaac&"
import script from "./embedded.vue?vue&type=script&lang=js&"
export * from "./embedded.vue?vue&type=script&lang=js&"
import style0 from "./embedded.vue?vue&type=style&index=0&id=8cf3aaac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports